import * as React from 'react';
export const WidgetContext = React.createContext(undefined);
export function useWidgetContext() {
    const context = React.useContext(WidgetContext);
    if (!context) {
        throw new Error('useWidgetContext must be used within a Widget component');
    }
    return context;
}
